/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ContactSalesControllerCreateMutationRequest, ContactSalesControllerCreateMutationResponse } from "../../models/contactSalesController/ContactSalesControllerCreate";

function getContactSalesControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/contact-sales` as const }  
  return res
}

/**
 * @summary Send a contact-sales message to the sales distribution list.
 * {@link /api/v1/contact-sales}
 */
export async function contactSalesControllerCreate(data?: ContactSalesControllerCreateMutationRequest, config: Partial<RequestConfig<ContactSalesControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ContactSalesControllerCreateMutationResponse, ResponseErrorConfig<Error>, ContactSalesControllerCreateMutationRequest>({ method : "POST", url : getContactSalesControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}